<!--
 * @Descripttion: 
 * @version: 
 * @Author: youquan.yu
 * @Date: 2020-08-11 09:52:56
 * @LastEditors: youquan.yu
 * @LastEditTime: 2020-09-28 10:05:37
-->
<template>
    <div class="MainDiv">
        <div class="contaniterDiv">
            <div class="searchBarDiv">
                <label
                    @click="changeSearchTag('month')"
                    :class="(searchTagValue == 'month') ? 'searchTagChoosed' : 'searchTagUnchoose'">
                        月访问量
                </label>
                <label
                    @click="changeSearchTag('day')"
                    :class="(searchTagValue == 'day') ? 'searchTagChoosed' : 'searchTagUnchoose'">
                        日访问量
                </label>
                <div class="searchChooseBarDiv">
                    <template v-if="searchTagValue=== 'month'">
                        <a-month-picker v-model:value="chooseMonthStartValue" placeholder="Start Month"/>
                        <label class="datePickerToLabel">~</label>
                        <a-month-picker v-model:value="chooseMonthEndValue" placeholder="End Month" />
                    </template>
                    <template v-if="searchTagValue=== 'day'">
                        <label class="searchChooseLabel" @click="getWeekDate()">本周</label>
                        <label class="searchChooseLabel" @click="getMonthDate()">本月</label>
                        <label class="searchChooseLabel" @click="getYearDate()">本年</label>
                        <a-date-picker v-model:value="chooseDayStartValue" placeholder="Start Day"/>
                        <label class="datePickerToLabel">~</label>
                        <a-date-picker v-model:value="chooseDayEndValue" placeholder="End Day"/>
                    </template>
                </div>
            </div>
            <div class="polygonalDiv">
                <polygonal :watchData="watchDataValue"></polygonal>
            </div>
        </div>
        <div class="visitPercentDiv">
            <visitpercent :watchData="watchDataValue"></visitpercent>
        </div>
        <div class="hotQuestionTopDiv">
            <hotquestiontop :watchData="watchDataValue"></hotquestiontop>
        </div>
        
    </div>
</template>
<script>
    import { useI18n } from "@/i18nPlugin";
    import { defineComponent, ref } from "vue";
    import polygonal from "../components/DateTable/polygonal.vue"
    import visitpercent from "../components/DateTable/visitpercent.vue"
    import hotquestiontop from "../components/DateTable/hotquestiontop.vue"
    var moment = require('moment')
    export default defineComponent({
        components: {
            polygonal,
            visitpercent,
            hotquestiontop
        },
        setup() {
            //常量
            const i18n = useI18n();
            const token = localStorage.getItem("userToken");

            //变量
            const searchTagValue = ref("month");
            const chooseMonthStartValue = ref(null);
            const chooseMonthEndValue = ref(null);
            const chooseDayStartValue = ref(null);
            const chooseDayEndValue = ref(null);
            const watchDataValue = ref({
                tag: searchTagValue,
                monthStart: chooseMonthStartValue,
                monthEnd: chooseMonthEndValue,
                dayStart: chooseDayStartValue,
                dayEnd: chooseDayEndValue
            });


            //方法
            const changeSearchTag = (tag) => {
                searchTagValue.value = tag
                if(tag == 'day') {
                    chooseDayStartValue.value = moment().subtract(30, 'days').format("YYYY-MM-DD")
                    chooseDayEndValue.value = moment().format("YYYY-MM-DD")
                    chooseMonthStartValue.value = null
                    chooseMonthEndValue.value = null
                }else if(tag == 'month') {
                    chooseMonthStartValue.value = moment().subtract(12, 'months').format("YYYY-MM-DD")
                    chooseMonthEndValue.value = moment().format("YYYY-MM-DD")
                    chooseDayStartValue.value = null
                    chooseDayEndValue.value = null
                }
            }
            const getWeekDate = () => {
                chooseDayStartValue.value = moment().week(moment().week()).startOf('week').format('YYYY-MM-DD');
                chooseDayEndValue.value = moment().week(moment().week()).endOf('week').format('YYYY-MM-DD');
            }
            const getMonthDate = () => {
                chooseDayStartValue.value = moment().month(moment().month()).startOf('month').format('YYYY-MM-DD');
                chooseDayEndValue.value = moment().month(moment().month()).endOf('month').format('YYYY-MM-DD');
            }
            const getYearDate = () => {
                chooseDayStartValue.value = moment().year(moment().year()).startOf('year').format('YYYY-MM-DD');
                chooseDayEndValue.value = moment().year(moment().year()).endOf('year').format('YYYY-MM-DD');
            }
            return {
                i18n,
                token,
                searchTagValue,
                chooseMonthStartValue,
                chooseMonthEndValue,
                chooseDayStartValue,
                chooseDayEndValue,
                watchDataValue,
                changeSearchTag,
                getWeekDate,
                getYearDate,
                getMonthDate
            }
        },
        mounted() {
            if (localStorage.getItem("userToken")) {
                this.chooseMonthStartValue = moment().subtract(12, 'months').format("YYYY-MM-DD")
                this.chooseMonthEndValue = moment().format("YYYY-MM-DD")
            }else {
                this.$router.push({path:'/ATS/Welcome'});
            }
        }
    })

</script>
<style scoped>
    .MainDiv {
        margin-top: 10px;
    }
    .contaniterDiv {
        width: 100%;
        background: #FFFFFF;
        border-radius: 8px;
        margin-bottom: 10px;
    }
    .visitPercentDiv {
        vertical-align: middle;
        display: inline-block;
        width: 64%;
        background: #FFFFFF;
        min-height: 750px;
    }
    .hotQuestionTopDiv {
        vertical-align: middle;
        display: inline-block;
        margin-left: 1%;
        width: 35%;
        background: #FFFFFF;
        min-height: 750px;
    }
    .searchBarDiv {
        padding: 2px 10px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e2e4e6;;
    }
    .datePickerToLabel {
        padding: 10px;
        font-size: 16px;
        font-weight: bold;
    }
    .searchChooseBarDiv {
        margin-left: auto;
    }
    .searchChooseLabel {
        cursor: pointer;
        padding: 10px;
        font-size: 14px;
        font-weight: bold;
    }
    .searchTagUnchoose {
        cursor: pointer;
        font-size: 16px;
        font-weight: bold;
        padding: 10px 10px;
        margin-right: 2px;
    }
    .searchTagChoosed {
        cursor: pointer;
        font-size: 16px;
        font-weight: bold;
        padding: 10px 10px;
        color: rgb(3, 160, 214);
        border-bottom: 2px solid rgb(3, 160, 214);

    }
    .polygonalDiv {
        margin-top: 10px;
    }
</style>